var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-new"},[(_vm.needInvite)?_c('AppIcon',{staticClass:"h-mr-2 mb-2",attrs:{"name":"lock-closed"}}):_vm._e(),_c('TextBlock',{staticClass:"arenaTitle",attrs:{"tag":"h2","size":1,"text":_vm.tournament.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }